import type { MetaCrewDownloadPageProps } from "./desktop-download";
/** GET /v1/public/desktop-app. size is bytes; the caller owns fetching. */
export type DesktopAppRelease = {
  available: boolean;
  version: string | null;
  size: number | null;
  publishedAt: string | null;
  downloadUrl: string | null;
};
/** Layout slots only. A release response must supply real download metadata. */
export const desktopReleaseSlots: DesktopAppRelease = {
  available: true,
  version: null,
  size: null,
  publishedAt: null,
  downloadUrl: null,
};
export const unavailableDesktopRelease: DesktopAppRelease = {
  available: false,
  version: null,
  size: null,
  publishedAt: null,
  downloadUrl: null,
};
export type PublicDownloadFlow = {
  key: string;
  id: string;
  name: string;
  route: "/login";
  component: "MetaCrewDownloadPage" | "InstallGuideDialog";
  note: string;
  args: MetaCrewDownloadPageProps;
  mobile?: boolean;
  dark?: boolean;
};
/** Public login/install states; there is no standalone landing or /download page. */
export const publicDownloadFlows: PublicDownloadFlow[] = [
  {
    key: "login-admin",
    id: "meta-crew-download--login-admin",
    name: "관리 콘솔 로그인 · Worker 내려받기",
    route: "/login",
    component: "MetaCrewDownloadPage",
    note: "로그인 카드 안 단일 Worker 내려받기와 설치 방법 다이얼로그. 배포 정보는 서버 응답 자리표시.",
    args: { loginScope: "admin" },
  },
  {
    key: "login-customer",
    id: "meta-crew-download--login-customer",
    name: "고객 콘솔 로그인 · Worker 내려받기",
    route: "/login",
    component: "MetaCrewDownloadPage",
    note: "고객 콘솔도 같은 로그인·설치 부품 사용.",
    args: { loginScope: "customer" },
  },
  {
    key: "login-no-release",
    id: "meta-crew-download--login-no-release",
    name: "로그인 · 배포본 없음",
    route: "/login",
    component: "MetaCrewDownloadPage",
    note: "available=false이면 내려받기 버튼을 숨기고 설치 방법 링크 유지.",
    args: { release: unavailableDesktopRelease },
  },
  {
    key: "login-mobile",
    id: "meta-crew-download--login-mobile",
    name: "로그인 · 모바일",
    route: "/login",
    component: "MetaCrewDownloadPage",
    note: "내려받기 대신 PC에서 열기 안내.",
    args: {},
    mobile: true,
  },
  {
    key: "login-dark",
    id: "meta-crew-download--login-dark",
    name: "로그인 · 다크",
    route: "/login",
    component: "MetaCrewDownloadPage",
    note: "공통 의미 토큰을 사용하는 다크 로그인.",
    args: {},
    dark: true,
  },
  {
    key: "install-guide",
    id: "meta-crew-download--install-guide",
    name: "설치 방법 · 4단계",
    route: "/login",
    component: "InstallGuideDialog",
    note: "내려받기 → 설치 및 Windows 보호 화면 → 8자리 연결 코드 → USB와 디버깅 허용.",
    args: { initialGuideOpen: true },
  },
  {
    key: "install-guide-mobile",
    id: "meta-crew-download--install-guide-mobile",
    name: "설치 방법 · 모바일",
    route: "/login",
    component: "InstallGuideDialog",
    note: "390px 설치 상세 다이얼로그. 본문만 스크롤하고 닫기 동작은 공통 Dialog 사용.",
    args: { initialGuideOpen: true },
    mobile: true,
  },
  {
    key: "install-guide-dark",
    id: "meta-crew-download--install-guide-dark",
    name: "설치 방법 · 다크",
    route: "/login",
    component: "InstallGuideDialog",
    note: "설치 4단계와 시스템 요구사항의 다크 상태.",
    args: { initialGuideOpen: true },
    dark: true,
  },
  {
    key: "install-guide-no-release",
    id: "meta-crew-download--install-guide-no-release",
    name: "설치 방법 · 배포본 없음",
    route: "/login",
    component: "InstallGuideDialog",
    note: "배포본 없음 안내와 설치 순서를 함께 표시. 다운로드 링크 없음.",
    args: { initialGuideOpen: true, release: unavailableDesktopRelease },
  },
  {
    key: "release-response",
    id: "meta-crew-download--release-response",
    name: "로그인 · API 응답 예시",
    route: "/login",
    component: "MetaCrewDownloadPage",
    note: "검증용 응답 A/B 재주입과 배포본 없음. 이 스토리의 값은 실제 배포 정보가 아님.",
    args: {},
  },
];
